import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import axios from 'axios';
import { getSiteKey } from '../../../components/RecaptchaProvider/RecaptchaProvider.utils';
import { getBusinessTypePath } from '../../../utils/api';
export function submitReview(_x, _x2, _x3) {
  return _submitReview.apply(this, arguments);
}
function _submitReview() {
  _submitReview = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref, _ref2, recaptchaToken) {
    var businessId, businessType, name, review, rating, location, payload, serverPath, path;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          businessId = _ref.businessId, businessType = _ref.businessType;
          name = _ref2.name, review = _ref2.review, rating = _ref2.rating, location = _ref2.location;
          payload = {
            author: name,
            text: review,
            rating: rating,
            'recaptcha-token': recaptchaToken,
            'recaptcha-site-key': getSiteKey(),
            location_id: location
          };
          serverPath = process.env.SERVER_URL || process.env.STORYBOOK_SERVER_URL;
          path = "".concat(serverPath, "businesses/").concat(getBusinessTypePath(businessType), "/").concat(businessId, "/website-reviews/");
          return _context.abrupt("return", axios.post(path, payload));
        case 6:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _submitReview.apply(this, arguments);
}